export default class IFCTypeToOBCategoryConverter
{
    constructor()
    {   

        
    

    }

    Convert(filetype, type, subtype)
    {
        switch(type)
        {
            case 'Wall':
                return "Wall";
            case 'Slab':
                return "Floor";
            case 'Pipesegment':
                return "Pipe";
            case 'Ductsegment':
                return "Duct";
            case 'Ductdamper':
                return "DuctAccessories";
            case 'Cablesegment':
                return "Cabletray";
            case "CablecarrierSegment":
                return "CableTray";
            case 'Controller':
                return "DuctAccessories";
            case 'Flowcontroller':
                return "DuctAccessories";
            case 'Flowsegment':
                switch(subtype)
                {
                    case 'IfcPipeSegmentType':
                        return "Pipe";
                    case 'IfcDuctSegmentType':
                        return "Duct";
                    case 'IfcCableCarrierSegmentType':
                        return "Cabletray";
                    default:
                        return "undefined";
                }
            case 'Standardwall':
                return "Wall";
            // case 'Buildingelement':
            //     return type;
            case 'Distributionelement':
                switch(filetype)
                {
                    case 'Installation':
                        return "DuctAccessories";
                    case 'Construction':
                        return "Wall";
                    default:
                        return "DuctAccessories";

                }
                
            // case 'Insulation':
            //     return "Insulation";




                

            default:
                return "undefined";

        }
    }

}